















































































































































































































import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { KCardHeader } from '@kasasa/fbase-components';
import { TextBoxDatePicker } from '@kasasa/portal-components';
import { DateTool } from '@/util';
import {
  ATM,
  ATMSettingsResource,
} from '@/api/atmsettings';

@Component({
  computed: mapState(['fiId']),
  components: {
    KCardHeader,
    'text-box-date-picker': TextBoxDatePicker,
  },
})
export default class ATMSettings extends Vue {
  headerItems: any = [
    {
      text: 'Rewards Configuration',
      disabled: false,
      link: false,
    },
    {
      text: 'ATM Settings',
      disabled: true,
    },
  ];

  @Inject('ATMSettingsResource')
  atmSettingsResource!: ATMSettingsResource;

  fiId!: number;

  allAtms: | ATM[] = [];

  currentDesignIndex: number = 0;

  atm: ATM | null = null;

  workingATM: ATM = ATMSettingsResource.createEmptyATM(null);

  loading: boolean = false;

  createAtmSettingsPressed: boolean = false;

  cancelling: boolean = false;

  saving: boolean = false;

  isDataModified: boolean = false;

  isEditable: boolean = false;

  valid: boolean = false;

  @Watch('fiId')
  mounted() {
    this.atm = null;
    this.allAtms = [];
    this.loading = true;
    this.atmSettingsResource
      .getMany(this.fiId)
      .then((res: ATM[]) => {
        this.allAtms = res;
        if (this.allAtms.length > 0) {
          this.atm = this.allAtms[0];
        } else {
          this.workingATM = ATMSettingsResource.createEmptyATM(null);
        }
        this.currentDesignIndex = this.getCurrentDesignIndex();
      })
      .catch((error) => {
        this.showError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  loadAtms() {
    this.allAtms = [];
    this.loading = true;
    this.atmSettingsResource
      .getMany(this.fiId)
      .then((res: ATM[]) => {
        this.allAtms = res;
        this.currentDesignIndex = this.getCurrentDesignIndex();
      })
      .catch((error) => {
        this.showError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @Watch('atm')
  initializeWorkingATM() {
    this.isDataModified = false;
    this.isEditable = false;
    this.createAtmSettingsPressed = false;
    if (this.atm) {
      Object.assign(this.workingATM, this.atm);
    } else {
      this.workingATM = ATMSettingsResource.createEmptyATM(null);
    }
  }

  getDescription(atm:ATM) : string {
    let startString : string = '';
    const atmIndex : number = this.getAtmIndex(atm);
    if (atmIndex === this.currentDesignIndex) {
      startString = 'Current ';
    }

    const startDateString = DateTool.toFriendlyFormatFromIsoFormatString(atm.designStartDate);
    if (this.allAtms.length === 1 || atmIndex === 0) {
      return `${startString}Settings Design - ${startDateString}`;
    }

    return `${startString}Settings Design - ${startDateString} - ${DateTool.subtractOneDay(this.allAtms[atmIndex - 1].designStartDate)}`;
  }

  getCurrentDesignIndex() : number {
    for (let i = 0; i < this.allAtms.length; i++) {
      if (DateTool.parseDate(this.allAtms[i].designStartDate) < new Date()) {
        return i;
      }
    }
    return -1;
  }

  getAtmIndex(atm: ATM) : number {
    const isEqual = (element : ATM) => element === atm;
    return this.allAtms.findIndex(isEqual);
  }

  editAtmSettings() {
    this.isEditable = true;
  }

  createAtmSettings() {
    this.createAtmSettingsPressed = true;
    this.isDataModified = false;
    this.isEditable = true;
    if (this.atm) {
      this.workingATM.designStartDate = DateTool.todayBackendDate();
      this.workingATM.designVersionId = null;
    } else {
      this.workingATM = ATMSettingsResource.createEmptyATM(null);
    }
  }

  @Watch('workingATM', { deep: true })
  onModification() {
    if (this.atm === null) {
      this.isDataModified = true;
      return;
    }
    if (this.workingATM.terminalFeeCalculationMethod !== this.atm!.terminalFeeCalculationMethod
          || this.workingATM.terminalFeeModulus !== this.atm!.terminalFeeModulus
          || this.workingATM.atmTransactionFilter !== this.atm!.atmTransactionFilter
          || this.workingATM.atmRefundAggregatorSetting !== this.atm!.atmRefundAggregatorSetting
          || this.workingATM.designStartDate !== this.atm!.designStartDate) {
      this.isDataModified = true;
    } else {
      this.isDataModified = false;
    }
  }

  isValid() {
    if (this.workingATM.terminalFeeCalculationMethod === '') {
      this.setError('Terminal Fee Calculation Method is required!');
      return false;
    }
    if (this.workingATM.terminalFeeCalculationMethod === 'CALCULATE_FROM_TRANSACTION_AMOUNT'
        && (this.workingATM.terminalFeeModulus === '' || this.workingATM.terminalFeeModulus === null)) {
      this.setError('Terminal Fee Modulus is required!');
      return false;
    }
    if (this.workingATM.atmTransactionFilter === '') {
      this.setError('ATM Transaction Filter is required!');
      return false;
    }
    if (this.workingATM.atmRefundAggregatorSetting === '') {
      this.setError('ATM Refund Aggregation is required!');
      return false;
    }
    const isDuplicateDate = (element : ATM) => element.designStartDate === this.workingATM.designStartDate
        && element.designVersionId !== this.workingATM.designVersionId;
    const duplicateDateIndex : number = this.allAtms.findIndex(isDuplicateDate);
    if (duplicateDateIndex > -1) {
      this.setError('Two Atm Settings cannot share the same start date!');
      return false;
    }
    return true;
  }

  saveATMSettings() {
    if (!this.isValid()) {
      return;
    }

    this.saving = true;
    this.atmSettingsResource
      .update(this.fiId, this.workingATM!)
      .then((result: any) => {
        this.atm = result;
        const al = new Alert('ATM Settings saved successfully.', NoticeClass.SUCCESS);
        al.setTimeout(4000);
        this.$store.dispatch('notices/add', al);
      })
      .finally(() => {
        this.saving = false;
        this.createAtmSettingsPressed = false;
        this.isEditable = false;
        this.loadAtms();
      })
      .catch((error) => {
        this.showError(error);
      });
  }

  setTerminalFeeModulusToNull() {
    this.workingATM.terminalFeeModulus = null;
  }

  setTerminalFeeModulusToExistingValue() {
    this.workingATM.terminalFeeModulus = this.atm!.terminalFeeModulus;
  }

  showError(error: any) {
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
